import React from "react";
import "../styles/Content.css";
import "../fonts/Roboto-Medium.ttf"
const Content = ({ children }) => {
  return <div className="content scroll">{children}</div>;
};
export default Content;